import React, { useEffect, useState } from 'react';
import './CompassOrientation.css';

const CompassOrientation = ({ compassState }) => {
  const [directionsSvg, setDirectionsSvg] = useState(null);
  const [directionSvg, setDirectionSvg] = useState(null);
  const [compassSvg, setCompassSvg] = useState(null);
  const [dialSvg, setDialSvg] = useState(null);
  const [targetDialSvg, setTargetDialSvg] = useState(null);

  useEffect(() => {
    const loadSvg = async (url, setSvg) => {
      const response = await fetch(url);
      const svgText = await response.text();
      setSvg(svgText);
    };

    loadSvg('/directions.svg', setDirectionsSvg);
    loadSvg('/direction.svg', setDirectionSvg);
    loadSvg('/compass.svg', setCompassSvg);
    loadSvg('/dial.svg', setDialSvg);
    loadSvg('/targetDial.svg', setTargetDialSvg);
  }, []);

  let backgroundColor = '';
  if (compassState.enableUVLED) {
    backgroundColor = 'purple';
  } else if (compassState.closed) {
    backgroundColor = 'lightgrey';
  }  

  return (
    <div className="compass-visualization" style={{ backgroundColor }}>
      <div
        className="svg-container directions-svg"
        dangerouslySetInnerHTML={{ __html: directionsSvg }}
      />
      <div
        className="svg-container svg-rotatable direction-svg"
        dangerouslySetInnerHTML={{ __html: directionSvg }}
        style={{ transform: `rotate(${compassState.direction || 0}deg)` }}
      />
      <div
        className="svg-container svg-rotatable compass-svg"
        dangerouslySetInnerHTML={{ __html: compassSvg }}
        style={{ transform: `rotate(${compassState.heading || 0}deg)` }}
      />
      <div
        className="svg-container svg-rotatable target-dial-svg"
        dangerouslySetInnerHTML={{ __html: targetDialSvg }}
        style={{ transform: `rotate(${-compassState.targetDial + compassState.heading || 0}deg)` }}
      />
      <div
        className="svg-container svg-rotatable dial-svg"
        dangerouslySetInnerHTML={{ __html: dialSvg }}
        style={{ transform: `rotate(${-compassState.dial + compassState.heading || 0}deg)` }}
      />
    </div>
  );
};

export default CompassOrientation;
